export { type LabelledListProps, default as LabelledList } from './LabelledList';
